import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-227e72ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "related-parts-skeleton" }
const _hoisted_2 = { class: "group-header mb-2" }
const _hoisted_3 = { class: "parts-list" }
const _hoisted_4 = { class: "item-info flex-1" }
const _hoisted_5 = { class: "item-actions flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skeletonCount, (i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "skeleton-group mb-4"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Skeleton, {
            width: "200px",
            height: "1.5rem",
            class: "mb-1"
          }),
          _createVNode(_component_Skeleton, {
            width: "300px",
            height: "1rem"
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (j) => {
            return _createElementVNode("div", {
              key: j,
              class: "skeleton-item flex justify-content-between align-items-center p-2 border-1 border-gray-200 border-round mb-2"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_Skeleton, {
                  width: "120px",
                  height: "1.2rem",
                  class: "mb-1"
                }),
                _createVNode(_component_Skeleton, {
                  width: "250px",
                  height: "1rem",
                  class: "mb-1"
                }),
                _createVNode(_component_Skeleton, {
                  width: "80px",
                  height: "0.9rem"
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Skeleton, {
                  width: "60px",
                  height: "1rem",
                  class: "mr-3"
                }),
                _createVNode(_component_Skeleton, {
                  width: "120px",
                  height: "2.5rem",
                  class: "mr-2"
                }),
                _createVNode(_component_Skeleton, {
                  width: "60px",
                  height: "2.5rem"
                })
              ])
            ])
          }), 64))
        ])
      ]))
    }), 128))
  ]))
}